import BaseRoute from 'uplisting-frontend/pods/base/route';

export default class ReportsIndexRoute extends BaseRoute {
  beforeModel() {
    this.router.replaceWith('insights.reports.index');
  }
}
